import React, { Component } from 'react';

export default class FilterContainer extends Component {
	componentDidMount(){
		setTimeout(() => {
    		this.props.passRefUpward && this.props.scrollRef && this.props.passRefUpward(this.refs[this.props.scrollRef], this.props.scrollRef)
		}, 0);
	}
	renderTitle(){
		if(this.props.title){
			return <div className="Filters__container__title">{this.props.title}</div>
		}
		return false
	}
	render() {
		return (
			<div ref={ this.props.scrollRef ? this.props.scrollRef : undefined } className={ "Filters__container" + (this.props.noScroll ? ' Filters__container--no-scroll' : '') } >
				{ this.renderTitle() }
				<div className="Filters__container__etc"></div>
				{ this.props.children ? this.props.children : false }
			</div>
		);
	}
}